import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { mdiCheckCircleOutline, mdiClockOutline, mdiLockOutline } from '@mdi/js'

import LabelBadge from '@/components/designSystem/Badges/LabelBadge.vue'
import type {
  LabelBadgeColor,
  LabelBadgeSize
} from '@/components/designSystem/Badges/LabelBadge.vue'
import { EligibilityResult } from '@/types/qualification-eligibility.types'


export default /*#__PURE__*/_defineComponent({
  __name: 'EligibilityChip',
  props: {
    result: {},
    size: { default: 'small' }
  },
  setup(__props: any) {



/** Resultado da pré-checagem (A8) → chip ao lado do médico. */
const CONFIG: Record<EligibilityResult, { label: string; color: LabelBadgeColor; icon: string }> = {
  [EligibilityResult.ELIGIBLE]: { label: 'Atende', color: 'green', icon: mdiCheckCircleOutline },
  [EligibilityResult.PRE_ALLOCATABLE]: {
    label: 'Pré-alocável',
    color: 'orange',
    icon: mdiClockOutline
  },
  [EligibilityResult.NOT_ELIGIBLE]: { label: 'Não atende', color: 'red', icon: mdiLockOutline }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(LabelBadge, {
    label: CONFIG[_ctx.result].label,
    color: CONFIG[_ctx.result].color,
    icon: CONFIG[_ctx.result].icon,
    size: _ctx.size,
    "data-testid": `eligibility-chip-${_ctx.result}`
  }, null, 8, ["label", "color", "icon", "size", "data-testid"]))
}
}

})